import * as React from "react";

import Layout from "../components/Layout";
import Hero from "../components/Hero";
import Features from "../components/Features";
import TrustedBy from "../components/TrustedBy";
import FeaturedProjects from "../components/FeaturedProjects";
import Archivements from "../components/Archivements";
import ContactUs from "../components/ContactUs";
import Newsletter from "../components/Newsletter";
import HomeBackground from "../components/Backgrounds/HomeBackground";

import Seo from "../components/Seo";

import { Slide } from "react-awesome-reveal";

const IndexPage = () => {
  return (
    <>
      <Layout>
        <Hero />
        <HomeBackground>
          <Slide direction="up" triggerOnce={true}>
            <Features />
            <TrustedBy />
            <FeaturedProjects />
            <Archivements />
            <ContactUs />
            <Newsletter />
          </Slide>
        </HomeBackground>
      </Layout>
    </>
  );
};

export default IndexPage;

export const Head = (props) => {
  return <Seo pathname={props.location.pathname} />;
};
